module.exports = ".header-dialog {\n  margin-top: 0%;\n  margin-bottom: 0%;\n  margin-right: 0%;\n  margin-left: 0%; }\n\n.header-danger {\n  background-color: #fa5c7c !important;\n  margin-top: -25px; }\n\n::ng-deep .mat-dialog-container {\n  padding: 0 !important;\n  margin: 0 !important; }\n\n.body-modal {\n  padding: 2rem !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/empresas/eliminar-empresa-modal/eliminar-empresa-modal.component.scss
// module id = ./src/app/administracion/empresas/eliminar-empresa-modal/eliminar-empresa-modal.component.scss
// module chunks = main